
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Die Ratschläge – im wahrsten Sinn – lauteten: Einen Zitteraal berühren und sich
einen elektrischen Schlag mit bis zu 600 Volt verpassen lassen war 1762 die
Empfehlung in einer wissenschaftlichen Schrift. Einen toten Maulwurf am Kopf
festbinden galt etwa um das Jahr 1000 als probates Mittel. Auch Knoblauch an den
Schläfen unter die Haut schieben war damals ein heisser Tipp, ebenso wie ein
heisses Eisen am Kopf zu applizieren. Um das Jahr 100 riet der griechische Arzt
Aretaios, einen Gänsefederkiel tief in die Nase zu rammen, sodass es kräftig
blutet. Verglichen damit war das tönerne Krokodil mit Getreide im Maul, das bei
den alten Ägyptern mit einem Leinenstreifen an den Kopf gebunden wurde, die
wohltuendere Therapie. Die Massage mit Rosenöl – das in anderen Kulturkreisen
als Schmerzmittel gilt – war wohl die angenehmste Behandlung. Schon die Götter
Horus und Re in der altägyptischen Mythologie litten übrigens an Kopfschmerzen.
Göttin Isis behandelte Re deshalb mit einer Koriandermus-Honig-Kopfbandage.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;